export interface InvoiceDetailRequestContext {
  invoiceDetailRequestId: number;
  detailLoading: boolean;
}

interface LoadCurrentInvoiceDetailsOptions<T> {
  context: InvoiceDetailRequestContext;
  invoiceId: number;
  selectedInvoiceId: () => number | null | undefined;
  fetchDetails: () => Promise<T>;
  applyDetails: (details: T) => void;
  loadStripeStatus: () => Promise<void>;
  onError: (error: unknown) => void;
}

export function invalidateInvoiceDetailRequest(
  context: InvoiceDetailRequestContext
): void {
  context.invoiceDetailRequestId += 1;
  context.detailLoading = false;
}

export async function loadCurrentInvoiceDetails<T>(
  options: LoadCurrentInvoiceDetailsOptions<T>
): Promise<void> {
  const requestId = options.context.invoiceDetailRequestId + 1;
  options.context.invoiceDetailRequestId = requestId;
  options.context.detailLoading = true;
  const isCurrent = () =>
    options.context.invoiceDetailRequestId === requestId &&
    options.selectedInvoiceId() === options.invoiceId;

  try {
    const details = await options.fetchDetails();
    if (!isCurrent()) return;
    options.applyDetails(details);
    await options.loadStripeStatus();
  } catch (error) {
    if (isCurrent()) options.onError(error);
  } finally {
    if (isCurrent()) options.context.detailLoading = false;
  }
}
